import { useState, useEffect } from 'react'
import axios from 'axios'

const useBlobImage = (avatarUrl: string) => {
  const [blobAvatarUrl, setBlobAvatarUrl] = useState<string>()

  useEffect(() => {
    const fetchImage = async () => {
      if (avatarUrl) {
        const response = await axios.get(avatarUrl, {
          responseType: 'blob'
        })

        const url = URL.createObjectURL(response.data)
        setBlobAvatarUrl(url)

        return () => URL.revokeObjectURL(url)
      } else {
        const canvas = document.createElement('canvas')
        canvas.width = 100
        canvas.height = 100

        const ctx = canvas.getContext('2d')
        if (ctx) {
          ctx.fillStyle = '#cccccc'
          ctx.fillRect(0, 0, canvas.width, canvas.height)
        }

        canvas.toBlob((blob) => {
          if (blob) {
            const url = URL.createObjectURL(blob)
            setBlobAvatarUrl(url)

            return () => URL.revokeObjectURL(url)
          }
        })
      }
    }

    fetchImage()
  }, [avatarUrl])

  return blobAvatarUrl
}

export { useBlobImage }
